import { AppBar, Box, CssBaseline, Toolbar } from "@mui/material";
import { ThemeProvider, Theme } from "@mui/material/styles";
import Loader from "components/Loader";
import useGlobalContext from "hooks/globalData";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useQuery } from "react-query";
import { ResponseOfString } from "services/KnowfullyAdminClient";
import getTheme from "styles/theme";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  appBar: {
    zIndex: 1275,
  },
  main: {
    flexGrow: 1,
    mt: 8,
    py: 4,
  },
};

const MinimalLayout = () => {
  const { configurationService } = useGlobalContext();
  const [theme, setTheme] = useState<Theme | null>(null);

  const { data: environment, isLoading } = useQuery<ResponseOfString>(
    "configurationService.getEnvironment",
    () => configurationService.getEnvironment()
  );

  useEffect(() => {
    if (!isLoading && environment?.data) {
      setTheme(getTheme(environment.data.toLowerCase()));
    }
  }, [environment, isLoading]);

  if (isLoading || !theme) return <Loader />;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={styles.root}>
        <AppBar position="fixed" sx={styles.appBar}>
          <Toolbar />
        </AppBar>
        <Box component="main" sx={styles.main}>
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MinimalLayout;
